// extracted by mini-css-extract-plugin
export default {"feed_wrapper":"feed_feed_wrapper__ZL1sf","order_numbers_wrapper":"feed_order_numbers_wrapper__13TOu","order_numbers":"feed_order_numbers__-c95P"};